/**************************************************
 * Nombre:       Anuncios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../../../Tema";
import {GRADIENTE} from "../../../../Constantes";
import dayjs from "dayjs";
import 'dayjs/locale/es';
import {irUrl} from "../../../../Utilidades/irUrl";
import {formatoFechaDays} from "../../../../Utilidades/formatoFechaDays";
import {useResponsive} from "../../../../Modulo_Responsive/Hooks/useResponsive"; // Importa el idioma español


const Anuncios = ({item}) => {
    dayjs.locale('es')
    const {sCell} = useResponsive()


    return (
        <Grid
            container
            justifyContent={'flex-end'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: sCell ? 'center' : 'flex-end'}}>
                <img src={item.img ? item.img : ''} width={sCell ? '70%' : '60%'} height={'auto'}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 10}}
                  sx={{justifyContent: 'flex-start', mt: sCell ? -10 : -25, mr: sCell ? 0 : 2}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{
                        borderRadius: 0,
                        border: 0.5,
                        borderColor: '#ffffff50',
                        background: 'rgba(255, 255, 255, 0.50)',
                        boxShadow: '0 4px 20px 0 rgba(0, 0, 0, 0.25)',
                        backdropFilter: 'blur(4px)',
                        py: 2,
                        px: 3
                    }}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{
                            fontSize: 28,
                            fontWeight: 700,
                            fontFamily: 'Inter',
                            lineHeight: 1.2
                        }}>{item.nombre}</Typography>
                    </Grid>


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{
                            fontSize: 16,
                            fontWeight: 500,
                            fontFamily: 'Inter',
                            color: theme.palette.primary.main,
                        }}>{formatoFechaDays(item.fecha)}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0.5}}>
                        <Typography sx={{
                            fontSize: 15,
                            fontWeight: 500,
                            fontFamily: 'Inter',
                            lineHeight: 1.2,
                            color: '#262626',
                            textOverflow: "ellipsis",
                            display: '-webkit-box',
                            overflow: 'hidden',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 2

                        }}>
                            {item.descripcion}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', mt: 1.5}}>
                        <Button
                            onClick={() => irUrl(item.link)}
                            sx={{background: GRADIENTE}}
                        >{item.nombreBoton}</Button>
                    </Grid>

                </Grid>
            </Grid>

        </Grid>
    )

}
export default Anuncios    